import type { JSX } from "react";
import { type UseFieldConfig, useField } from "react-final-form";
import { ErrorBox, Label, Input as StyledInput } from "./stylings";

interface IOwnProps {
    label: string;
    name: string;
    required?: boolean;
}

type IProps = IOwnProps & UseFieldConfig;

function Input({ name, label, required, ...props }: IProps): JSX.Element {
    const {
        input,
        meta: { touched, error },
    } = useField<any, HTMLInputElement>(name, props);
    return (
        <div>
            <Label $error={error && touched}>
                {label}
                {required ? "*" : ""}:
                <StyledInput $error={!!error && touched} type="text" {...input} />
                {touched && error && <ErrorBox>{error}</ErrorBox>}
            </Label>
        </div>
    );
}

export default Input;
